import Vue from 'vue';

const PAGE_VIEW_EVENT = 'page_view';

/**
 * Send a page view through VueGTM after a completed router navigation.
 */
export function trackPageView() {
  if (!Vue.gtm || typeof Vue.gtm.push !== 'function') return;

  Vue.gtm.push({
    event: PAGE_VIEW_EVENT,
  });
}
